export const getFallbackVoucherCode = (state: RootState) => {
  // Wenn die VisitorId schon mal mit einem Gutscheincode angefragt hat, dann nimm diese,
  // ansonsten nimm den Standard-Gutscheincode.
  // https://app.asana.com/1/1174270169444561/project/1174272655772669/task/1210481908537935?focus=true
  return state.refererPing.data?.visitorId_voucherCode || state.ensfields.ens_fallback_vouchercode;
};
